var showcaseVersionsInter = (function () {
  return {
    init: init,
  };

  function init() {
    document.addEventListener(
      "DOMContentLoaded",
      fillShowcaseVersionTableColumns
    );

    window.addEventListener("resize", fillShowcaseVersionTableColumns);
  }

  function fillShowcaseVersionTableColumns() {
    var visibleColumns = [],
      hasAlpha = false,
      tables = document.querySelectorAll(".showcase-versions__table");

    if (tables.length > 0) {
      tables.forEach(function (table, index) {
        tableBody = table.querySelector(".showcase-versions__tbody");

        if (tableBody != null) {
          tableBody.innerHTML = "";

          // Define the numbers of column as per device
          var numColumns = 5;
          if (window.innerWidth < 641) {
            numColumns = 2;
            for (var i = 0; i < showcaseVersionExtra.data.length; i++) {
              if (
                showcaseVersionExtra.data[i].length > 10 ||
                showcaseVersionExtra.data.length < 10
              ) {
                numColumns = 1;
                hasAlpha = true;
              }
            }
          } else if (window.innerWidth < 980) {
            numColumns = 4;
          }

          // Get prepared data
          var rows = prepareRowColumns(showcaseVersionExtra.data, numColumns);

          if (rows.length > 0) {
            rows.forEach(function (item, index) {
              var row = document.createElement("div");
              row.classList.add("showcase-versions__row");
              if (item.length > 0) {
                item.forEach(function (cell, cellIndex) {
                  var column = document.createElement("div");
                  column.classList.add("showcase-versions__col");
                  var cellHtml = '<div class="showcase-versions__td">';

                  if (cell != "" && cell != undefined) {
                    visibleColumns[cellIndex] = true;

                    if (index >= 9 && cellIndex == numColumns - 1) {
                      cellHtml +=
                        '<a href="https://www.browserstack.com/list-of-browsers-and-platforms/live" class="showcase-versions__all-link">View all</a>';
                    } else if (
                      showcaseVersionExtra.combination == "devices" ||
                      showcaseVersionExtra.in_os_array == true
                    ) {
                      cellHtml +=
                        '<span class="showcase-versions__number">' +
                        cell +
                        "<span>";
                    } else {
                      // Remove non-numeric characters (except dot)
                      var versions_number = cell.replace(/[^0-9\.]/g, "");
                      // Remove ".0" if it's at the end of the string
                      if (versions_number.substr(-2) === ".0") {
                        versions_number = versions_number.slice(0, -2);
                      }
                      // Convert to a floating-point number and floor it
                      var dynamics_version = Math.floor(
                        parseFloat(versions_number)
                      );
                      // Remove non-alphabetic characters and capitalize the first letter of each word
                      var sub_text_browser = cell.replace(/[^a-zA-Z\s]/g, ""); // Remove non-alphabetic characters
                      sub_text_browser = sub_text_browser.replace(
                        /\b\w/g,
                        function (char) {
                          return char.toUpperCase(); // Capitalize the first letter of each word
                        }
                      );

                      if (
                        showcaseVersionExtra.dynamics_link != undefined &&
                        showcaseVersionExtra.dynamics_link[dynamics_version] !=
                          undefined
                      ) {
                        cellHtml +=
                          '<a class="showcase-versions__link" href="' +
                          showcaseVersionExtra.dynamic_browser_version_link +
                          "-" +
                          dynamics_version +
                          '" title="' +
                          showcaseVersionExtra.dynamic_browser_version_link_title +
                          versions_number +
                          '"><span class="showcase-versions__number">' +
                          versions_number +
                          "</span></a>";
                      } else {
                        cellHtml +=
                          '<span class="showcase-versions__number">' +
                          versions_number +
                          "</span>";
                      }

                      if (sub_text_browser != "") {
                        cellHtml +=
                          '<span class="showcase-versions__status">' +
                          sub_text_browser +
                          "</span>";
                      }
                    }
                  }
                  cellHtml += "</div>";
                  column.innerHTML = cellHtml;
                  row.appendChild(column);
                });

                tableBody.appendChild(row);
              }
            });
          }

          //
          tableRows = tableBody.querySelectorAll(".showcase-versions__row");

          if (tableRows.length > 0) {
            tableRows.forEach(function (row) {
              var columns = row.querySelectorAll(".showcase-versions__col");
              //dynamic column as per content
              if (columns.length > 0) {
                columns.forEach(function (column, i) {
                  if (!visibleColumns[i]) {
                    column.classList.add("hide");
                  } else {
                    column.classList.remove("hide");
                  }
                });
              }
            });
          }
          if (hasAlpha) {
            tableBody.classList.add("has-one-column");
            tableBody.classList.remove("has-two-column");
          } else {
            tableBody.classList.add("has-two-column");
            tableBody.classList.remove("has-one-column");
          }

          var allColumns = table.querySelectorAll(".showcase-versions__col");
          if (allColumns.length > 10) {
            tableBody.classList.add("hide-sec-col");
          } else {
            tableBody.classList.remove("hide-sec-col");
          }
        }
      });
    }
  }

  function prepareRowColumns(filterArr, numColumns) {
    filterArr = filterArr.slice(0, 10 * numColumns);
    var initArr = filterArr.slice(),
      colNeeded = 0;
    if (filterArr.length % numColumns != 0) {
      var colNeeded = numColumns - (filterArr.length % numColumns);
      for (var i = 0; i < colNeeded; i++) {
        filterArr.push(""); // Add new elements to the array (e.g., 4, 5, 6, ...)
      }
    }

    var numItems = filterArr.length;
    var numRows = Math.min(10, Math.ceil(numItems / numColumns));
    var arr = [];
    // Initialize the array for rows
    for (var i = 0; i < numRows; i++) {
      arr[i] = [];
    }
    var result = [];
    if (initArr.length < 9 && colNeeded > 1) {
      result = reorderArray(initArr, colNeeded);
    } else {
      // Loop over each column
      for (var i = 0; i < numRows; i++) {
        for (var j = i; j < filterArr.length; j += numRows) {
          result.push(filterArr[j]);
        }
      }
    }

    // Populate the array
    for (var i = 0; i < numItems; i++) {
      var rowIndex = Math.floor(i / numColumns);
      if (rowIndex < numRows) {
        arr[rowIndex].push(result[i]);
      }
    }
    return arr;
  }

  function reorderArray(arr, colNeeded) {
    var last = [],
      first = [];
    // Loop through the array to separate the items
    for (var i = 0; i < arr.length; i++) {
      if (arr.length - i > colNeeded) {
        if (i % 2 === 0) {
          first.push(arr[i]);
        } else {
          last.push(arr[i]);
        }
      } else {
        first.push(arr[i]);
      }
    }
    result = first.concat(last);
    for (var i = 0; i < colNeeded; i++) {
      result.push("");
    }
    return result;
  }
})();

showcaseVersionsInter.init();
